"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Operator = void 0;
/* eslint-disable no-restricted-syntax */
var ethers_1 = require("ethers");
var did_resolver_interface_1 = require("@ew-did-registry/did-resolver-interface");
var did_1 = require("@ew-did-registry/did");
var resolver_1 = __importDefault(require("./resolver"));
var constants_1 = require("../constants");
var utils_1 = require("../utils");
var PublicKey = did_resolver_interface_1.DIDAttribute.PublicKey, ServicePoint = did_resolver_interface_1.DIDAttribute.ServicePoint;
var BigNumber = ethers_1.utils.BigNumber, formatBytes32String = ethers_1.utils.formatBytes32String;
/**
 * To support/extend this Class, one just has to work with this file.
 * All the supporting functions are stored as private methods (i.e. with the '_' symbol)
 * One can easily extend the methods available by researching the smart contract functionality,
 * as well as by understanding how the read is performed.
 */
var Operator = /** @class */ (function (_super) {
    __extends(Operator, _super);
    /**
   * @param { IdentityOwner } owner - entity which controls document updatable by this operator
   */
    function Operator(owner, settings) {
        var _this = _super.call(this, owner.provider, settings) || this;
        _this._keys = {
            privateKey: '',
            publicKey: '',
        };
        var _a = _this.settings, address = _a.address, abi = _a.abi;
        _this._owner = owner;
        _this._didRegistry = new ethers_1.ethers.Contract(address, abi, _this._owner);
        _this._keys.publicKey = owner.publicKey;
        return _this;
    }
    Operator.prototype.getAddress = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.address) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this._owner.getAddress()];
                    case 1:
                        _a.address = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, this.address];
                }
            });
        });
    };
    Operator.prototype.did = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = "did:" + this.settings.method + ":";
                        return [4 /*yield*/, this.getAddress()];
                    case 1: return [2 /*return*/, _a + (_b.sent())];
                }
            });
        });
    };
    Operator.prototype.getPublicKey = function () {
        return this._keys.publicKey;
    };
    /**
   * Relevant did should have positive cryptocurrency balance to perform
   * the transaction. Create method saves the public key in smart contract's
   * event, which can be qualified as document creation
   *
   * @param did
   * @param context
   * @returns Promise<boolean>
   */
    Operator.prototype.create = function () {
        return __awaiter(this, void 0, void 0, function () {
            var did, attribute, updateData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.did()];
                    case 1:
                        did = _a.sent();
                        return [4 /*yield*/, this.readOwnerPubKey(did)];
                    case 2:
                        if (_a.sent()) {
                            return [2 /*return*/, true];
                        }
                        attribute = did_resolver_interface_1.DIDAttribute.PublicKey;
                        updateData = {
                            algo: did_resolver_interface_1.Algorithms.Secp256k1,
                            type: did_resolver_interface_1.PubKeyType.VerificationKey2018,
                            encoding: did_resolver_interface_1.Encoding.HEX,
                            value: { publicKey: "0x" + this.getPublicKey(), tag: did_resolver_interface_1.KeyTags.OWNER },
                        };
                        return [4 /*yield*/, this.update(did, attribute, updateData)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    /**
    * Sets attribute value in DID document identified by the did
    *
    * @example
    *```typescript
    * import {
    * Operator, DIDAttribute, Algorithms, PubKeyType, Encoding
    *  } from '@ew-did-registry/did-resolver';
    * import { Keys } from '@ew-did-registry/keys';
    *
    * const ownerKeys = new Keys();
    * const operator = new Operator(ownerKeys);
    * const pKey = DIDAttribute.PublicKey;
    * const updateData = {
    *     algo: Algorithms.ED25519,
    *     type: PubKeyType.VerificationKey2018,
    *     encoding: Encoding.HEX,
    *     value: new Keys().publicKey,
    * };
    * const validity = 10 * 60 * 1000;
    * const updated = await operator.update(did, pKey, updateData, validity);
    * ```
    *
    * @param { string } did - did associated with DID document
    * @param { DIDAttribute } didAttribute - specifies updated section in DID document. Must be 31
    * bytes or shorter
    * @param { IUpdateData } updateData
    * @param { number } validity - time in milliseconds during which
    *                              attribute will be valid
    * @returns Promise<number>
    */
    Operator.prototype.update = function (did, didAttribute, updateData, validity) {
        if (validity === void 0) { validity = Number.MAX_SAFE_INTEGER; }
        return __awaiter(this, void 0, void 0, function () {
            var registry, method;
            return __generator(this, function (_a) {
                registry = this._didRegistry;
                method = didAttribute === PublicKey || didAttribute === ServicePoint
                    ? registry.setAttribute
                    : registry.addDelegate;
                if (validity < 0) {
                    throw new Error('Validity must be non negative value');
                }
                return [2 /*return*/, this._sendTransaction(method, did, didAttribute, updateData, validity)];
            });
        });
    };
    /**
    * Revokes the delegate from DID Document
    * Returns true on success
    *
    * @param { string } did - did of identity of interest
    * @param { PubKeyType } delegateType - type of delegate of interest
    * @param { string } delegate - did of delegate of interest
    * @returns Promise<boolean>
    */
    Operator.prototype.revokeDelegate = function (did, delegateType, delegateDID) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._sendTransaction(this._didRegistry.revokeDelegate, did, did_resolver_interface_1.DIDAttribute.Authenticate, {
                            type: delegateType,
                            delegate: utils_1.addressOf(delegateDID),
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    /**
    * Revokes attribute from DID Document
    * Returns true on success
    *
    * @param { string } did - did of identity of interest
    * @param { DIDAttribute } attributeType - type of attribute to revoke
    * @param { IUpdateData } updateData - data required to identify the correct attribute to revoke
    * @returns Promise<boolean>
    */
    Operator.prototype.revokeAttribute = function (did, attributeType, updateData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._sendTransaction(this._didRegistry.revokeAttribute, did, attributeType, updateData)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    /**
    * Changes the owner of particular decentralised identity
    * Returns true on success
    *
    * @param { string } did - did of current identity owner
    * @param { string } newOwner - did of new owner that will be set on success
    * @returns Promise<boolean>
    */
    Operator.prototype.changeOwner = function (did, newOwner) {
        return __awaiter(this, void 0, void 0, function () {
            var tx, receipt, event_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this._didRegistry.changeOwner(utils_1.addressOf(did), utils_1.addressOf(newOwner))];
                    case 1:
                        tx = _a.sent();
                        return [4 /*yield*/, tx.wait()];
                    case 2:
                        receipt = _a.sent();
                        event_1 = receipt.events.find(function (e) { return (e.event === 'DIDOwnerChanged'); });
                        if (!event_1)
                            return [2 /*return*/, false];
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        throw new Error(error_1);
                    case 4: return [2 /*return*/, true];
                }
            });
        });
    };
    /**
    * Revokes authentication methods, public keys and delegates from DID document
    *
    * @example
    * ```typescript
    *import { Operator } from '@ew-did-registry/did-resolver';
    *import { Keys } from '@ew-did-registry/keys';
    *
    * const ownerKeys = new Keys();
    * const operator = new Operator(ownerKeys);
    * const updated = await operator.deactivate(did);
    * ```
    *
    * @param { string } did
    * @returns Promise<boolean>
    */
    Operator.prototype.deactivate = function (did) {
        return __awaiter(this, void 0, void 0, function () {
            var document;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.read(did)];
                    case 1:
                        document = _a.sent();
                        return [4 /*yield*/, this._revokeAuthentications(did, document.authentication, document.publicKey)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this._revokePublicKeys(did, document.publicKey)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this._revokeServices(did, document.service)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
   * Revokes authentication attributes
   *
   * @param did
   * @param auths
   * @param publicKeys
   * @private
   */
    Operator.prototype._revokeAuthentications = function (did, auths, publicKeys) {
        var publicKeys_1, publicKeys_1_1;
        var e_1, _a;
        return __awaiter(this, void 0, void 0, function () {
            var pk, match, type, e_1_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 6, 7, 12]);
                        publicKeys_1 = __asyncValues(publicKeys);
                        _b.label = 1;
                    case 1: return [4 /*yield*/, publicKeys_1.next()];
                    case 2:
                        if (!(publicKeys_1_1 = _b.sent(), !publicKeys_1_1.done)) return [3 /*break*/, 5];
                        pk = publicKeys_1_1.value;
                        match = pk.id.match(constants_1.delegatePubKeyIdPattern);
                        if (!match) return [3 /*break*/, 4];
                        type = auths.find(function (auth) { return auth.publicKey === match[0]; }) ? did_resolver_interface_1.PubKeyType.SignatureAuthentication2018
                            : did_resolver_interface_1.PubKeyType.VerificationKey2018;
                        return [4 /*yield*/, this.revokeDelegate(did, type, "did:" + did_1.Methods.Erc1056 + ":" + pk.ethereumAddress)];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [3 /*break*/, 1];
                    case 5: return [3 /*break*/, 12];
                    case 6:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 12];
                    case 7:
                        _b.trys.push([7, , 10, 11]);
                        if (!(publicKeys_1_1 && !publicKeys_1_1.done && (_a = publicKeys_1.return))) return [3 /*break*/, 9];
                        return [4 /*yield*/, _a.call(publicKeys_1)];
                    case 8:
                        _b.sent();
                        _b.label = 9;
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        if (e_1) throw e_1.error;
                        return [7 /*endfinally*/];
                    case 11: return [7 /*endfinally*/];
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    /**
   * Revokes Public key attribute
   *
   * @param did
   * @param publicKeys
   * @private
   */
    Operator.prototype._revokePublicKeys = function (did, publicKeys) {
        var publicKeys_2, publicKeys_2_1;
        var e_2, _a;
        return __awaiter(this, void 0, void 0, function () {
            var pk, match, encoding, e_2_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 6, 7, 12]);
                        publicKeys_2 = __asyncValues(publicKeys);
                        _b.label = 1;
                    case 1: return [4 /*yield*/, publicKeys_2.next()];
                    case 2:
                        if (!(publicKeys_2_1 = _b.sent(), !publicKeys_2_1.done)) return [3 /*break*/, 5];
                        pk = publicKeys_2_1.value;
                        match = pk.id.match(constants_1.pubKeyIdPattern);
                        if (!match) return [3 /*break*/, 4];
                        encoding = Object.values(did_resolver_interface_1.Encoding)
                            .find(function (enc) { return pk[utils_1.encodedPubKeyName(enc)]; });
                        return [4 /*yield*/, this.revokeAttribute(did, did_resolver_interface_1.DIDAttribute.PublicKey, {
                                type: did_resolver_interface_1.DIDAttribute.PublicKey,
                                value: {
                                    id: pk.id,
                                    publicKey: pk[utils_1.encodedPubKeyName(encoding)],
                                    tag: pk.id.split('#')[1],
                                },
                            })];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [3 /*break*/, 1];
                    case 5: return [3 /*break*/, 12];
                    case 6:
                        e_2_1 = _b.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 12];
                    case 7:
                        _b.trys.push([7, , 10, 11]);
                        if (!(publicKeys_2_1 && !publicKeys_2_1.done && (_a = publicKeys_2.return))) return [3 /*break*/, 9];
                        return [4 /*yield*/, _a.call(publicKeys_2)];
                    case 8:
                        _b.sent();
                        _b.label = 9;
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        if (e_2) throw e_2.error;
                        return [7 /*endfinally*/];
                    case 11: return [7 /*endfinally*/];
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    /**
   * Revokes service attributes
   *
   * @param did
   * @param services
   * @private
   */
    Operator.prototype._revokeServices = function (did, services) {
        var services_1, services_1_1;
        var e_3, _a;
        return __awaiter(this, void 0, void 0, function () {
            var service, e_3_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 6, 7, 12]);
                        services_1 = __asyncValues(services);
                        _b.label = 1;
                    case 1: return [4 /*yield*/, services_1.next()];
                    case 2:
                        if (!(services_1_1 = _b.sent(), !services_1_1.done)) return [3 /*break*/, 5];
                        service = services_1_1.value;
                        return [4 /*yield*/, this.revokeAttribute(did, did_resolver_interface_1.DIDAttribute.ServicePoint, {
                                type: did_resolver_interface_1.DIDAttribute.ServicePoint,
                                value: {
                                    id: service.id,
                                    type: service.type,
                                    serviceEndpoint: service.serviceEndpoint,
                                },
                            })];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [3 /*break*/, 1];
                    case 5: return [3 /*break*/, 12];
                    case 6:
                        e_3_1 = _b.sent();
                        e_3 = { error: e_3_1 };
                        return [3 /*break*/, 12];
                    case 7:
                        _b.trys.push([7, , 10, 11]);
                        if (!(services_1_1 && !services_1_1.done && (_a = services_1.return))) return [3 /*break*/, 9];
                        return [4 /*yield*/, _a.call(services_1)];
                    case 8:
                        _b.sent();
                        _b.label = 9;
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        if (e_3) throw e_3.error;
                        return [7 /*endfinally*/];
                    case 11: return [7 /*endfinally*/];
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    /**
   * Private function to send transactions
   *
   * @param method
   * @param did
   * @param didAttribute
   * @param updateData
   * @param validity
   * @param overrides
   * @private
   */
    Operator.prototype._sendTransaction = function (method, did, didAttribute, updateData, validity, overrides) {
        return __awaiter(this, void 0, void 0, function () {
            var identity, name, value, params, tx, receipt, event_2, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        identity = utils_1.addressOf(did);
                        name = formatBytes32String(this._composeAttributeName(didAttribute, updateData));
                        value = utils_1.hexify(didAttribute === PublicKey || didAttribute === ServicePoint
                            ? updateData.value
                            : updateData.delegate);
                        params = [
                            identity,
                            name,
                            value,
                        ];
                        if (validity !== undefined) {
                            params.push(validity);
                        }
                        if (overrides) {
                            params.push(overrides);
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, method.apply(void 0, params)];
                    case 2:
                        tx = _a.sent();
                        return [4 /*yield*/, tx.wait()];
                    case 3:
                        receipt = _a.sent();
                        event_2 = receipt.events.find(function (e) { return (didAttribute === did_resolver_interface_1.DIDAttribute.PublicKey && e.event === 'DIDAttributeChanged')
                            || (didAttribute === did_resolver_interface_1.DIDAttribute.ServicePoint && e.event === 'DIDAttributeChanged')
                            || (didAttribute === did_resolver_interface_1.DIDAttribute.Authenticate && e.event === 'DIDDelegateChanged'); });
                        return [2 /*return*/, new BigNumber(event_2.blockNumber)];
                    case 4:
                        e_4 = _a.sent();
                        throw new Error(e_4.message);
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
   * Util functions to create attribute name, supported by read method
   *
   * @param attribute
   * @param updateData
   * @private
   */
    Operator.prototype._composeAttributeName = function (attribute, updateData) {
        var algo = updateData.algo, type = updateData.type, encoding = updateData.encoding;
        switch (attribute) {
            case did_resolver_interface_1.DIDAttribute.PublicKey:
                return "did/" + did_resolver_interface_1.DIDAttribute.PublicKey + "/" + algo + "/" + type + "/" + encoding;
            case did_resolver_interface_1.DIDAttribute.Authenticate:
                return updateData.type;
            case did_resolver_interface_1.DIDAttribute.ServicePoint:
                return "did/" + did_resolver_interface_1.DIDAttribute.ServicePoint + "/" + updateData.value.type;
            default:
                throw new Error('Unknown attribute name');
        }
    };
    return Operator;
}(resolver_1.default));
exports.Operator = Operator;
//# sourceMappingURL=operator.js.map